var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 16 / icon_heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1929 3.81294C12.1167 2.72902 10.3718 2.72902 9.2956 3.81294L8 5.12839L6.7044 3.81294C5.62821 2.72902 3.88333 2.72902 2.80714 3.81294C1.73095 4.89687 1.73095 6.66483 2.80714 7.74875L4.10274 9.06419L8 13L11.8973 9.06419L13.1929 7.74875C14.269 6.66483 14.269 4.89687 13.1929 3.81294Z",
    stroke: "#E30031",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.c958c3387131fc0e60039039ffbd4628.svg";
export { ForwardRef as ReactComponent };